type MedicinePackageFormatterOptions = {
   form: string;
   dose: string;
   packageContent: string;
};

export const formatMedicinePackage = (options: MedicinePackageFormatterOptions): string => {
   return `${options.form} ${options.dose} ${options.packageContent}`;
};
